module.exports = __webpack_public_path__ + "img/pt-27.afe591d6.jpg";